import { NEXT_PUBLIC_API_URL, STATIC_ASSET_BASE_URL } from '../constants/main';
import { assetPathToCdnUrl, useCdn } from './cdn.utils';

export const getAssetUrl = (path: string) => assetPathToCdnUrl(STATIC_ASSET_BASE_URL + path);
export const getAssetAbsoluteUrl = (path: string) => {
    if (useCdn) return assetPathToCdnUrl(STATIC_ASSET_BASE_URL + path);
    return NEXT_PUBLIC_API_URL + STATIC_ASSET_BASE_URL + path;
};
